var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2051 5.30765L9.61535 1.71791M9.61535 1.71791L6.02561 5.30765M9.61535 1.71791L9.61535 11.7692",
    stroke: "currentColor",
    strokeWidth: 1.4359,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58974 7.67412C4.58974 7.195 4.1365 6.8377 3.69133 7.01484C1.57935 7.85522 1 9.60214 1 12.9939C1 18.4889 2.52062 19.6667 9.61539 19.6667C16.7102 19.6667 18.2308 18.4889 18.2308 12.9939C18.2308 9.60213 17.6514 7.85521 15.5394 7.01483C15.0943 6.83769 14.641 7.195 14.641 7.67411V7.67411C14.641 7.99896 14.857 8.27764 15.1536 8.41015C15.3786 8.51066 15.5583 8.61902 15.7044 8.73216C16.3777 9.25366 16.7949 10.2487 16.7949 12.9939C16.7949 15.7392 16.3777 16.7342 15.7044 17.2557C15.3285 17.5468 14.7299 17.8063 13.7111 17.9817C12.6926 18.157 11.3643 18.2308 9.61539 18.2308C7.86649 18.2308 6.53815 18.157 5.5197 17.9817C4.50088 17.8063 3.90225 17.5468 3.5264 17.2557C2.85308 16.7342 2.4359 15.7392 2.4359 12.9939C2.4359 10.2487 2.85308 9.25366 3.5264 8.73216C3.67247 8.61903 3.85219 8.51066 4.07714 8.41015C4.37372 8.27764 4.58974 7.99896 4.58974 7.67412V7.67412Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.368c5869cb1cfe7b01a95d7495f0b699.svg";
export { ForwardRef as ReactComponent };